@if (permiso.roles.includes('Técnico')) {
  <app-vista-tecnicos-genericos></app-vista-tecnicos-genericos>
} @else {
  <mat-tab-group>
    <mat-tab label="Servicios Técnicos Pendientes">
      <ng-template matTabContent>
        <app-eventos-tecnicos-genericos></app-eventos-tecnicos-genericos>
      </ng-template>
    </mat-tab>
    <mat-tab label="Servicios Técnicos Finalizados">
      <ng-template matTabContent>
        <app-eventos-tecnicos-finalizados-genericos></app-eventos-tecnicos-finalizados-genericos>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
}
